import { render } from "./InfoTip.vue?vue&type=template&id=cb674a7c"
import script from "./InfoTip.vue?vue&type=script&lang=js"
export * from "./InfoTip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__